import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class UniqueNameService {
    generate(items: Array<any>, item: any, prefix: string = '', suffix: string = ''): string {
        let index = items.indexOf(item);

        let uniqueName = prefix;

        if (index > 0) {
            for (let i = 0; i < index; i++) uniqueName += "'";
        }

        return uniqueName + suffix;
    }
}
